'use client';
import * as All from '@/element/common/elmntbase';
import { useRouter, useSearchParams } from 'next/navigation';

export default function Pginate({ pagination, ...props }: any) {
    const router = useRouter();
    const searchParams = useSearchParams();
    const loadPaginated = (i: any) => {
        const _params = new URLSearchParams(searchParams.toString());
        _params.set("page", i);
        router.push('?' + _params);
    }

    return (
        <>
            {pagination?.pagination?.allPageNumbers?.length > 1 ?
                <div className="pagination-wrapper mt-3 my-5">
                    <All.Pagination className='justify-content-center'>
                        <All.PaginationItem className='prev' role="button" key={"page previouss" + 2} onClick={(e) => loadPaginated(pagination?.pagination?.previousPageNumber)} disabled={pagination?.pagination?.previousPageNumber ? false : true} as={'span'}>
                            Prev
                        </All.PaginationItem>
                        {pagination?.pagination?.allPageNumbers?.map((_page: any) => (
                                                        
                            <All.PaginationItem className='' role="button" key={"page" + _page + _page + 2} onClick={(e) => loadPaginated(_page)} active={pagination?.currentPage == _page ? true : false} as={'span'}>
                                {_page <=9 ? '0'+_page :_page}                         
                            </All.PaginationItem>
                        ))}
                        <All.PaginationItem className='next' role="button" key={"page Next" + 54152} onClick={(e) => loadPaginated(pagination?.pagination?.nextPageNumber)} disabled={pagination?.pagination?.nextPageNumber ? false : true} as={'span'}>
                            Next
                        </All.PaginationItem>
                    </All.Pagination>
                </div>
                : null
            }
        </>
    )
}